import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models (g204/models/g204.go)
// ============================================================

export interface FG140 {
  fg140_01: string;        // 折讓單號 (PK)
  fg140_11: string | null; // 折讓日期 (ISO date)
  fg140_12: string;        // 公司代號
  fg140_13: string;        // 公司名稱
  fg140_14: number;        // 折讓總淨額
  fg140_15: number;        // 折讓總稅額
  fg140_16: string;        // 幣別
  fg140_17: string;        // 修改狀態
  fg140_18: number;        // 明細行數
  fg140_19: string;        // 備註
  fg140_20: string;        // 業務員
  fg140_80: string;        // 核准狀態 N/P
  fg140_89: string;
  fg140_90: number;        // version
  fg140_91: string;        // 修改人
  fg140_92: string | null; // 修改日期
  fg140_93: string;        // 建立人

  // Associations
  details?: FG141[];
  sub_details?: FG142[];
}

export interface FG141 {
  fg141_01: string;  // 折讓單號 (FK)
  fg141_02: number;  // 明細序號
  fg141_11: string;  // 交運單號
  fg141_12: string;  // 公司代號
  fg141_13: number;  // 折讓淨額
  fg141_14: number;  // 稅額
  fg141_15: number;  // 折讓金額
  fg141_16: string;  // 幣別
  fg141_17: number;  // numeric(10,2)
  fg141_18: string;  // 客訴單號
  fd141_34: string;
  fg141_90: number;

  // Sub-detail association
  sub_details?: FG142[];
}

export interface FG142 {
  fg142_01: string;  // 折讓單號 (FK)
  fg142_02: number;  // 父項次 (FK)
  fg142_03: number;  // 子項次
  fg142_11: string;  // 出貨單號
  fg142_12: number;  // 折讓淨額
}

// ============================================================
// Request / Response types
// ============================================================

export interface G204ListResponse {
  data: FG140[];
  total: number;
  page: number;
  size: number;
}

export interface G204CreateRequest {
  master: Partial<FG140>;
  details: Partial<FG141>[];
  sub_details: Partial<FG142>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const g204Api = {
  async list(page = 1, size = 20): Promise<G204ListResponse> {
    const res = await apiClient.get('/api/g204', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FG140> {
    const res = await apiClient.get(`/api/g204/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: G204CreateRequest): Promise<FG140> {
    const res = await apiClient.post('/api/g204', data);
    return res.data;
  },

  async update(id: string, data: G204CreateRequest): Promise<FG140> {
    const res = await apiClient.put(`/api/g204/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/g204/${encodeURIComponent(id)}`);
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/g204/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
